import styled from 'styled-components';

export const PhotographyWrapper = styled.div`
  background: white; color: #1b264f;
  .photo-section { max-width: 1360px; margin: auto; padding: 72px 40px; }
  .photo-hero { position: relative; z-index: 1; padding-top: 36px; }
  .photo-split { display: grid; grid-template-columns: 1fr 1.08fr; gap: 56px; align-items: center; }
  .photo-eyebrow { font: 700 14px/1.5 Poppins, sans-serif; letter-spacing: .14em; text-transform: uppercase; color: #2c5bff; margin: 0 0 14px; }
  h1 { font: 600 clamp(36px, 3.8vw, 56px)/1.13 Poppins, sans-serif; letter-spacing: -.045em; color: #1b264f; margin: 0 0 24px; text-transform: none; }
  h1 span { display: block; color: #2c5bff; }
  .photo-title { font: 600 clamp(28px, 3vw, 42px)/1.2 Poppins, sans-serif; letter-spacing: -.035em; text-transform: none; margin: 0 0 20px; color: #1b264f; }
  .photo-copy { font: 400 18px/1.7 'Nunito Sans', sans-serif; color: #52617e; margin: 0 0 24px; max-width: 660px; }
  .photo-hero-image { display: block; width: 100%; height: 560px; object-fit: cover; border-radius: 16px; }
  .photo-actions { display: flex; align-items: center; flex-wrap: wrap; gap: 24px; }
  .photo-primary { background: #2c5bff; color: white; border: 0; border-radius: 8px; padding: 18px 26px; font: 600 15px/1.5 Poppins, sans-serif; cursor: pointer; }
  .photo-primary:hover { background: #2049d6; }
  .photo-link { color: #2c5bff; font: 600 16px/1.5 'Nunito Sans', sans-serif; text-decoration: underline; text-underline-offset: 4px; }
  .photo-promises { display: flex; flex-wrap: wrap; gap: 12px 20px; margin: 24px 0 0; padding: 0; list-style: none; font: 600 15px/1.5 'Nunito Sans', sans-serif; }
  .photo-promises li::before { content: '✓'; margin-right: 8px; color: #2c5bff; }
  .photo-centered { text-align: center; }
  .photo-centered .photo-copy { margin-left: auto; margin-right: auto; }
  .photo-grid { display: grid; grid-template-columns: repeat(3, minmax(0,1fr)); gap: 24px; margin-top: 32px; }
  h3 { color: #1b264f; font: 600 20px/1.4 Poppins, sans-serif; text-transform: none; margin: 0 0 12px; }
  .photo-quality { padding-top: 72px; }
  .photo-quality-image { width: 100%; height: 460px; object-fit: cover; border-radius: 16px; display: block; }
  .photo-feature-list { list-style: none; padding: 0; margin: 28px 0 0; }
  .photo-feature-list li { padding: 0 0 0 24px; margin: 0 0 22px; border-left: 3px solid #dce5ff; }
  .photo-feature-list h3 { font-size: 18px; margin-bottom: 6px; }
  .photo-feature-list p { font: 400 16px/1.65 'Nunito Sans', sans-serif; color: #52617e; margin: 0; }
  .photo-band { padding: 0; background: #f6f8fc; }
  .photo-process-steps { display: grid; grid-template-columns: repeat(3, minmax(0,1fr)); gap: 40px; margin-top: 40px; text-align: left; }
  .photo-process-step { border-top: 1px solid #cbd5e9; padding-top: 22px; }
  .photo-step-number { display: block; font: 600 30px/1.2 Poppins, sans-serif; color: #2c5bff; margin-bottom: 18px; }
  .photo-process-step p { font: 400 17px/1.65 'Nunito Sans', sans-serif; color: #52617e; margin: 0; }
  .photo-related-section { padding-bottom: 36px; }
  .photo-related-grid { grid-template-columns: repeat(4,minmax(0,1fr)); }
  .photo-related { display: block; text-decoration: none; color: #1b264f; border: 1px solid #e4e8ef; border-radius: 14px; overflow: hidden; text-align: left; background: white; }
  .photo-related:hover { box-shadow: 0 10px 26px #1b264f10; }
  .photo-related img { display: block; width: 100%; height: 180px; object-fit: cover; }
  .photo-related-content { padding: 20px; }
  .photo-related h3 { font-size: 18px; }
  .photo-related p { color: #52617e; font: 400 15px/1.6 'Nunito Sans', sans-serif; margin-bottom: 12px; }
  .photo-related-arrow { color: #2c5bff; font-weight: 600; font-size: 15px; }
  .photo-tour-link { margin: 24px 0 0; }
  .photo-faq-layout { padding-top: 36px; display: grid; grid-template-columns: .8fr 1.2fr; gap: 64px; align-items: start; }
  .photo-faq details { border-bottom: 1px solid #e4e8ef; padding: 20px 0; }
  .photo-faq details:first-child { padding-top: 0; }
  .photo-faq summary { cursor: pointer; font: 600 18px/1.5 Poppins, sans-serif; color: #1b264f; }
  .photo-faq p { margin: 16px 0 0; font: 400 17px/1.7 'Nunito Sans', sans-serif; color: #52617e; }
  .photo-final-section { padding-top: 0; padding-bottom: 64px; }
  .photo-final { display: grid; grid-template-columns: 1.15fr 1fr; background: #1b264f; border-radius: 16px; overflow: hidden; }
  .photo-final-copy { padding: 36px; }
  .photo-final .photo-title { color: white; font-size: clamp(28px, 2.7vw, 36px); margin-bottom: 16px; }
  .photo-final .photo-eyebrow { color: #b7c8ff; }
  .photo-final .photo-copy { color: #d7dfef; font-size: 17px; margin-bottom: 20px; }
  .photo-final .photo-link { color: white; }
  .photo-final-visual { position: relative; min-width: 0; }
  .photo-final-visual img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }
  button:focus-visible, a:focus-visible, summary:focus-visible { outline: 3px solid #7c9aff; outline-offset: 5px; }
  @media (max-width: 991px) { .photo-split { gap: 32px; } .photo-related-grid { grid-template-columns: repeat(2,minmax(0,1fr)); } }
  @media (max-width: 767px) {
    .photo-section { padding: 44px 20px; }
    .photo-hero { padding-top: 28px; }
    .photo-split { grid-template-columns: 1fr; gap: 28px; }
    h1 { font-size: clamp(34px, 8.5vw, 48px); }
    .photo-copy { font-size: 17px; }
    .photo-hero-image { height: 340px; }
    .photo-grid { grid-template-columns: 1fr; gap: 16px; margin-top: 24px; }
    .photo-quality { padding-top: 44px; }
    .photo-quality-image { height: 320px; }
    .photo-process-steps { grid-template-columns: 1fr; gap: 28px; margin-top: 28px; }
    .photo-process-step { display: grid; grid-template-columns: 36px 1fr; column-gap: 16px; padding-top: 20px; }
    .photo-step-number { grid-row: span 2; font-size: 26px; margin-bottom: 0; }
    .photo-process-step h3 { font-size: 19px; margin-bottom: 8px; }
    .photo-process-step p { grid-column: 2; font-size: 16px; }
    .photo-related-section { padding-bottom: 24px; }
    .photo-related-grid { grid-template-columns: repeat(2,minmax(0,1fr)); gap: 12px; }
    .photo-related img { height: 150px; }
    .photo-related-content { padding: 16px 12px; }
    .photo-related h3 { font-size: 16px; }
    .photo-related p { font-size: 14px; }
    .photo-faq-layout { grid-template-columns: 1fr; gap: 28px; padding-top: 24px; }
    .photo-faq summary { font-size: 16px; }
    .photo-final-section { padding-top: 0; }
    .photo-final { display: block; text-align: center; }
    .photo-final-copy { padding: 28px 24px; }
    .photo-final .photo-actions { justify-content: center; gap: 20px; }
    .photo-final-visual { display: none; }
  }
`;
